import { render, staticRenderFns } from "./EditCustomBank.vue?vue&type=template&id=ff725938"
import script from "./EditCustomBank.vue?vue&type=script&lang=js"
export * from "./EditCustomBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports